<template>
  <a :href="orderDetailUrl">
    <div
      class="record-list__row-wrapper"
      @click="handleClick"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    >
      <div class="record-list__row-header">
        <div>
          <span class="record-list__row-header__order-id">#{{ order._id }}</span>
          <span class="record-list__row-header__space-dot">•</span>
          <span class="record-list__row-header__service-name" v-if="order.service_name">
            <!-- &nbsp;•&nbsp; -->
            {{ order.service_name }}
          </span>
        </div>
        <div v-if="order.supplier_name" class="record-list__row-header__supplier">
          <span>{{ $t('advance_order_list.supplier') }}</span>
          <span>{{ order.supplier_name }}</span>
          <img
            class="lazyload"
            :src="order.supplier_avatar"
            v-img-fallback="'/assets/images/supplier_avatar.png'"
          />
        </div>
      </div>
      <div class="record-list__row">
        <StatusBadge :order="order" />
        <div class="record__create-by" v-if="employee">
          <p v-if="order.user_name">{{ order.user_name }}</p>
          <p v-if="order.user_id">{{ order.user_id }}</p>
          <p v-if="createTime">{{ createTime }}</p>
        </div>
        <div class="record__address">
          <DropoffPoints :order="order" :points="order.path" />
        </div>

        <div class="record__price">
          <img :src="paymentMethodIcon" width="24" />
          <vue-numeric
            :currency="order.currency_symbol"
            :value="order.total_fee"
            read-only
          ></vue-numeric>
        </div>
        <div class="record__cod">
          <vue-numeric
            v-if="order.total_cod"
            :currency="order.currency_symbol"
            :value="order.total_cod"
            read-only
          ></vue-numeric>
        </div>
        <div class="record__stages">
          <OrderStages :data="order.callback_logs" />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'
// import { getServiceDetail } from '@/plugins/util';
// import { getOrderDataToReuse } from '@/utils/order';
// import { serviceDetail } from '@/store/api/order';

import DropoffPoints from './DropoffPoints'
import StatusBadge from './StatusBadge'
import OrderStages from '../OrderStages'

export default {
  name: 'RecordRow',
  components: {
    DropoffPoints,
    StatusBadge,
    OrderStages
  },
  props: {
    employee: {
      type: Boolean
    },
    order: {
      type: Object
    },
    onClick: {
      type: Function
    }
  },
  data() {
    return {
      isMouseEnter: false,
      showShareLink: false,
      isEnterShareUrl: false,
      timeoutCheckEnterShareUrl: null,
      SHARE_URL_STATUS: [
        this.$constants.ORDER_STATUS.ACCEPTED,
        this.$constants.ORDER_STATUS.IN_PROCESS,
        this.$constants.ORDER_STATUS.COMPLETED,
        this.$constants.ORDER_STATUS.FAILED
      ],
      advanceToolsStyle: {}
    }
  },
  computed: {
    ...mapGetters(['services']),
    orderDetailUrl() {
      let url = '#'
      if (this.order && this.order._id) {
        url = `${window.location.origin}/record/${this.order._id}`
      }
      return url
    },
    orderShareUrl() {
      let url = ''
      if (this.order.user_id && this.order._id) {
        return `${process.env.VUE_APP_CLOUD_BASE_URL}/share-order/${this.order._id}/${this.order.user_id}`
      }
      return url
    },
    paymentMethodIcon() {
      switch (this.order.payment_method) {
        case this.$constants.PAYMENT_METHODS.CASH:
          return '/assets/images/icons/Cash.svg'
        case this.$constants.PAYMENT_METHODS.BALANCE:
          if (this.order.is_child_account || this.order.is_postpaid) {
            return '/assets/images/icons/Corporate.svg'
          }
          return '/assets/images/icons/PersonalBalance.svg'
        case this.$constants.PAYMENT_METHODS.MOMO:
          return '/assets/images/icons/Momo.svg?ver=1'
        case this.$constants.PAYMENT_METHODS.ZALOPAY:
          return '/assets/images/icons/ZaloPayIcon.svg?ver=1'
        // case this.$constants.PAYMENT_METHODS.SMARTPAY:
        //   return '/assets/images/logo_SmartPay.png?ver=1'
        case this.$constants.PAYMENT_METHODS.VIETTELPAY:
          return 'https://ahamoveimg.s3-ap-southeast-1.amazonaws.com/Logo+Partners/Logo_ViettelPay.png?ver=1'
        case this.$constants.PAYMENT_METHODS.SHOPEEPAY:
          return 'https://ahamoveimg.s3.ap-southeast-1.amazonaws.com/Logo+Partners/Logo_ShopeePay.png?ver=1'
        case this.$constants.PAYMENT_METHODS.CARD:
          return (
            (this.order.payment_details && this.order.payment_details.icon_url) ||
            '/assets/images/icons/Cash.svg'
          )
        case this.$constants.PAYMENT_METHODS.BUSINESS_ACCOUNT:
          return '/assets/images/icons/BusinessAccount.svg'
        default:
          return '/assets/images/icons/Cash.svg'
      }
    },
    shareLinkVisible() {
      // return this.SHARE_URL_STATUS.includes(this.order.status)
      return true
    },
    createTime() {
      return (
        (this.order &&
          this.order.create_time &&
          this.$moment.unix(this.order.create_time).format('HH:mm DD/MM/YYYY')) ||
        ''
      )
    }
  },
  methods: {
    handleClick(event) {
      if (event && !event.ctrlKey && !event.metaKey) {
        event.stopPropagation()
        event.preventDefault()

        // this.$router.push({
        //   name: "record_detail",
        //   params: { id: this.order._id },
        //   query: this.$route.query
        // });
      }

      this.$emit('onClick', this.order)
      this.$store.dispatch('setActiveOrder', this.order)
    },
    openInNewWindow() {
      if (this.orderDetailUrl) {
        window.open(this.orderDetailUrl, '_blank')
      }
    },
    handleClickShareUrl() {
      this.showShareLink = !this.showShareLink
    },
    handleMouseEnterShareUrl() {
      this.isEnterShareUrl = true
    },
    handleMouseLeaveShareUrl() {
      this.showShareLink = false
      this.isEnterShareUrl = false
    },
    handleMouseLeaveShareUrlBtn() {
      this.timeoutCheckEnterShareUrl = setTimeout(() => {
        if (!this.isEnterShareUrl) {
          this.showShareLink = false
        }
      }, 200)
    },
    handleMouseEnter($event) {
      if (this.isMouseEnter) return

      this.isMouseEnter = true

      const parent =
        $event &&
        $event.path &&
        $event.path.find((p) => {
          return p.className === 'record-list__body'
        })
      const parentScrollTop = (parent && parent.scrollTop) || 0
      const left = 46
      const rowHeight = event.target.offsetHeight
      const toolBoxHeight =
        $event.target.lastChild.className === 'record__advance-tools'
          ? $event.target.lastChild.offsetHeight
          : 80
      let top = $event.target.offsetTop - parentScrollTop + rowHeight / 2 - toolBoxHeight / 2
      this.advanceToolsStyle = {
        top: `${top}px`,
        left: `${left}px`
      }
      // console.log('$event.target', $event)
      // console.log(JSON.stringify(this.advanceToolsStyle))
    },
    handleMouseLeave() {
      if (!this.showShareLink) {
        this.isMouseEnter = false
      }
    }
  },
  beforeDestroy() {
    if (this.timeoutCheckEnterShareUrl) {
      clearTimeout(this.timeoutCheckEnterShareUrl)
    }
  }
}
</script>

<i18n src="@/locales2/share/orderTools.json"></i18n>

<style lang="scss" scoped>
// width of first cell & shadow
$width_of_first_table_cell: 250px;

a:link {
  text-decoration: none;
}

.record-list__row-wrapper {
  position: relative;
  transition: box-shadow 0.1s ease-in;
  border: 1px solid transparent;
  border-bottom-color: #f2f2f2;

  .record-list__row-header {
    padding: 0 15px; //0 32px 0 20px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    background-color: hsla(0, 0%, 96%, 0.5);
    // #fafafa;
    border-radius: 4px 4px 0 0;

    span:first-child {
      // font-weight: 500;
    }

    .record-list__row-header__order-id {
      font-size: 13px;
      color: #666;
    }

    .record-list__row-header__space-dot {
      padding: 0 7px;
      color: #666;
    }

    .record-list__row-header__service-name {
      font-size: 13px;
      color: #666;
      padding: 0;
      margin-left: -4px;
    }

    .record-list__row-header__supplier {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #666;

      span {
        margin: 0 4px;
      }

      img {
        width: 22px;
        height: 22px;
        border-radius: 2px; //50%;
        // margin-right: 6px;
      }
    }
  }

  &:hover {
    box-shadow: 0 6px 10px 0 rgba(131, 134, 163, 0.12);
    border: 1px solid #bcbcbc !important;

    .record-list__row-header {
      border-bottom: 1px solid #bcbcbc;
      background-color: rgba(26, 26, 26, 0.05);
    }
  }
}

.record__advance-tools {
  // display: flex;
  align-items: center;
  height: auto; //110px;
  width: 36px;
  background: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 63px;
  position: fixed;
  z-index: 5;

  .info-icon {
    margin: 15px 0 15px 7px;
  }

  .arrow-right {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 9px solid #fff;
    position: absolute;
    top: calc(50% - 5px);
    right: -9px;
  }
}

.record-list__row {
  min-height: 64px;
  align-items: flex-start;
  padding: 15px 0;
  cursor: pointer;

  > div {
    padding: 0 3px;
  }

  .record__create-at,
  .record__id {
    font-size: 13px;
  }

  .record__address,
  .record__cod,
  .record__price,
  .record__status {
    font-size: 14px;
  }

  .record__address {
    padding: 0 15px;
  }

  .record__cod {
    color: #007cff;
    font-weight: 500;
  }

  .record__price {
    color: #ff8200;
    font-weight: 500;
    padding-right: 20px;

    img {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
    }
  }

  .record__service {
    color: #7a8189;
  }

  .record__create-by {
    > p {
      margin-bottom: 4px;

      &:last-child {
        color: #7a8189;
        margin-bottom: 0;
      }

      &:not(:first-child) {
        font-size: 13px;
      }
    }
  }
}
</style>

<style lang="scss">
.record__advance-tools {
  .info-icon:hover {
    svg {
      path {
        fill: #1a1a1a;
      }
    }
  }

  .share-order-menu {
    display: initial;

    .v-menu__activator {
      display: initial;

      &.v-menu__activator--active {
        display: flex;
      }
    }

    &.active {
      display: flex;
    }
  }
}

.tools__more__menu-content {
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  width: 320px;
  color: #1a1a1a;

  .tools__more__share-order {
    padding: 12px;
  }
}
</style>
